import {
  BadgeSlot,
  CardStack,
  FrontCard,
  GhostCardBack,
  GhostCardMid,
} from "./styles";
import { CardStackIllustrationProps } from "./types";

/**
 * Decorative card-stack illustration shared across empty states: two ghost cards
 * fanned behind a primary front card. The front card content is supplied via
 * children (e.g. an icon or a mini chart), with an optional badge floating over
 * its top-right corner. Marked aria-hidden as it is purely decorative.
 */
export const CardStackIllustration: React.FC<CardStackIllustrationProps> = ({
  children,
  badge,
}) => {
  return (
    <CardStack aria-hidden="true">
      <GhostCardBack />
      <GhostCardMid />
      <FrontCard>{children}</FrontCard>
      {badge && <BadgeSlot>{badge}</BadgeSlot>}
    </CardStack>
  );
};
